/* eslint-disable camelcase */
export enum IncomeTypes {
  alimony,
  retirement,
  employee_business_expenses,
  interest,
  sole_proprietorship,
  capital_gains,
  installment_sale,
  rental_real_estate,
  royalty,
  farming,
  trust,
  partnership,
  s_corporation,
  regular_corporation,
}

export enum SelfEmployed {
  sole_proprietorship = "sole_proprietorship",
  partnership = "partnership",
  s_corporation = "s_corporation",
  regular_corporation = "regular_corporation",
}

export enum AdditionalIncomeType {
  SocialSecurity = "Social Security",
  Pension = "Pension",
  IraDistribution = "IRA Distribution",
  IRA401K = "IRA/401(k)",
  RentalIncome = "Rental Income",
  ChildSupport = "Child Support",
  Alimony = "Alimony",
  NoteReceivable = "Note Receivable",
}

// Represents the allow-listed fields for adding/updating a new additional_income record
export type AdditionalIncomePayload = {
  id?: number;
  borrower_entity: number;
  include_in_other: boolean;
  include_in_ratios: boolean;
  loan_application_id: number;
  notes: string;
  operator_income_type: AdditionalIncomeType | string;
};

// Represents the complete fields for an additional_income record
export type AdditionalIncomeShape = AdditionalIncomePayload & {
  description?: string;
  effective_description?: string;
  final_monthly_income?: string; // Decimal as string
  is_on_tax_returns?: boolean;
  monthly_income?: string; // Decimal as string
  monthly_income_from_docs?: string; // Decimal as string
  start_date?: string | null;
};

export enum PaystubIncomeAggregationPayType {
  BasePay = "base_pay",
  OvertimePay = "overtime_pay",
  BonusPay = "bonus_pay",
  CommissionPay = "commission_pay",
  OtherPay = "other_pay",
}

export enum TaxYearsToUse {
  minus1And2 = "Minus1And2",
  minus2And3 = "Minus2And3",
  docsData = "DocsData",
}

export interface TaxIncomeSection {
  section_key: string;
  heading: string;
  subsections: TaxIncomeSubsection[];
  year_minus_two_total: string;
  year_minus_one_total: string;
  ytd_total: string;
  monthly_total: string;
}

export type IncomeAggregationPayload = {
  key: string;
  borrower_entity: number;
  calculation_method: string;
  document_type: string;
  document_data_is_monthly: boolean;
  gross_up_override: number;
  include_in_ratios: boolean;
  notes: string;
  other_year_1: number;
  other_year_2: number;
  show_gross_up: boolean;
  show_other: boolean;
  sub_key: string;
  sub_key_field: string;
  year_1_override: number;
  year_1: number;
  year_2: number;
};

export type IncomeAggregationShape = IncomeAggregationPayload & {
  id?: number;
  loan_application_id: number;
};

export type DocumentFieldAggregation = {
  type: string;
  display_text: string;
  reference_text: string;
  section: string;
  operation: string;
  fixed_value: string;
  year_minus_two_aggregated_value: number;
  year_minus_one_aggregated_value: number;
  ytd_aggregated_value: number;
  monthly_aggregated_value: number;
  excluded_from_total: boolean;
};

enum IncomeReportedByType {
  IncomeReportedByTypeEmployment = "Employment",
  OwnedRealEstate = "OwnedRealEstate",
}

type IncomeReportedBy = {
  id: number;
  type: IncomeReportedByType;
};

type TaxIncomeSubsectionOverrideValue = {
  name: string;
  description: string;
  operation: "subtract";
  value: number;
};

export interface TaxIncomeSubsection {
  aggregation: IncomeAggregationShape;
  field_aggregations: DocumentFieldAggregation[];
  year_minus_two_sub_total: number;
  year_minus_one_sub_total: number;
  ytd_sub_total: number;
  calculated_gross_up_percent: number;
  ownership_weighted_sub_total: number;
  monthly_total: number;
  income_reported_by: IncomeReportedBy;
  override_values: TaxIncomeSubsectionOverrideValue[];
}
